export function parseSettings(
  settings: string[],
  parameter: string
): string | null {
  for (let i = 0; i < settings.length; i++) {
    if (settings[i].includes(parameter)) {
      const [_, value] = settings[i].split('.');
      return value;
    }
  }
  return null;
}

export function parseUserSettings(
  settings: string[],
  parameter: string
): string | null {
  const substring = settings.find((str) => str.includes(parameter));
  if (!substring) {
    return null;
  }
  const lastDotIndex = substring.lastIndexOf('.');
  if (lastDotIndex === -1) {
    return null;
  }
  return substring.substring(lastDotIndex).replace(/\./g, '');
}
